// import React from 'react'
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// css
import "../../assets/css/dashboard.scss";

// Image
// svg
import dashboard_logo from "../../assets/images/dashboard/dashboard_logo.svg";
import SearchIcon from "../../assets/images/dashboard/SearchIcon.svg";
import NotificationIcon from "../../assets/images/dashboard/NotificationIcon.svg";
import SettingIcon from "../../assets/images/dashboard/SettingIcon.svg";
import ClockIcon from "../../assets/images/dashboard/ClockIcon.svg";
import ClockIconBlack from "../../assets/images/dashboard/ClockIconBlack.svg";
import PulseIcon from "../../assets/images/dashboard/PulseIcon.svg";
import PulseIconBlue from "../../assets/images/dashboard/PulseIconBlue.svg";
import DoctorIcon from "../../assets/images/dashboard/DoctorIcon.svg";
import DoctorIconBlue from "../../assets/images/dashboard/DoctorIconBlue.svg";
import HospitalIcon from "../../assets/images/dashboard/HospitalIcon.svg";
import HospitalIconBlue from "../../assets/images/dashboard/HospitalIconBlue.svg";
import PharmacyIcon from "../../assets/images/dashboard/PharmacyIcon.svg";
import PharmacyIconBlack from "../../assets/images/dashboard/PharmacyIconBlack.svg";
import LaboratoryIcon from "../../assets/images/dashboard/LaboratoryIcon.svg";
import PatientIcon from "../../assets/images/dashboard/PatientIcon.svg";
import PatientIconBlue from "../../assets/images/dashboard/PatientIconBlue.svg";
import Bannerpromo from "../../assets/images/dashboard/Bannerpromo.svg";
import BannerpromoBlue from "../../assets/images/dashboard/BannerpromoBlue.svg";
import DownIcon from "../../assets/images/dashboard/DownIcon.svg";
import DownIconBlue from "../../assets/images/dashboard/DownIconBlue.svg";
import LeftDropIcon from "../../assets/images/dashboard/LeftDropIcon.svg";
import BloodIconBlue from "../../assets/images/dashboard/BloodIconBlue.svg";
import BloodIconBlack from "../../assets/images/dashboard/BloodIconBlack.svg";
import HomeServiceIcon from "../../assets/images/dashboard/HomeServiceIcon.svg";
import HomeServiceIconBlue from "../../assets/images/dashboard/HomeServiceIconBlue.svg";

// png
import SampleImg from "../../assets/images/dashboard/SampleImg.png";
import DashboardCom from "../../components/DashboardComponents/DashboardCom";
import { Dropdown } from "antd";
// import FullScreenMenu from '../components/DashboardComponents/FullScreenMenu';

const FullScreenMenu = ({
  menuDropDownFullScreen,
  setMenuDropDownFullScreen,
  menuLeftText,
  menuIconCenter,
  menuIconLeftPadding,
  menuLeftRightDropDown1,
  menuLeftRightDropDown2,
  setMobileMenu1,
  MobileMenu1,
  menuActiveLinkColor,
  setMenuActiveLinkColor,
}) => {
  return (
    <div>
      <div
        className={`mt-lg-4 mt-0 pt-1 d-flex align-items-center ${menuIconCenter} ${menuIconLeftPadding}`}
      >
        <div className=" row" style={{ display: `${menuLeftText}`, width: "100%" }} >
          <div
            className={`${menuLeftRightDropDown1}    d-flex align-items-center ${menuIconCenter}`}
          >
            <div className="   dashboard-left-icon">
              <img 
              
              src={`${
                menuDropDownFullScreen.name === "dashboard" ? ClockIcon : ClockIconBlack 
              }`}
              alt="" />
            </div>

            <Link className="maweidi-link " to="/dashboardcom">
              <span style={{ display: `${menuLeftText}` }}>
                <p
                  className={`mb-0 pl-lg-3 dashboard-left-icon-text  ${
                    menuDropDownFullScreen.name === "dashboard"
                      ? "seleted-menu"
                      : ""
                  } `}
                  style={{ color: "#535353" }}
                  onClick={() => {
                    setMenuDropDownFullScreen({
                      ...menuDropDownFullScreen,
                      name: "dashboard",
                      toggle: !menuDropDownFullScreen.toggle,
                    });
                    setMobileMenu1(!MobileMenu1);
                  }}
                >
                  Dashboard
                </p>
              </span>
            </Link>
          </div>

          <div
            className={` ${menuLeftRightDropDown2}  px-0 d-flex align-items-center justify-content-end`}
          >
            {/* <img 
                        onClick={() => {
setMenuDropDownFullScreen(
    { name: "dashboard", toggle: !menuDropDownFullScreen.toggle }
)

                        }} 
                        src={DownIcon} alt="" style={{ display: `${menuLeftText}` }} /> */}
          </div>

          {/* { menuDropDownFullScreen.toggle && menuDropDownFullScreen.name === 'dashboard' &&

                        <p>sdf</p>
                      
                    } */}
        </div>
      </div>

      <div
        className={`mt-lg-4 mt-0 pt-1 d-flex align-items-center ${menuIconCenter} ${menuIconLeftPadding}`}
      >
        <div className=" row" style={{ display: `${menuLeftText}`, width: "100%" }}>
          <div
            className={`${menuLeftRightDropDown1} d-flex align-items-center ${menuIconCenter}`}
          >
            <div className="  dashboard-left-icon">
              <img className="py-1" 
              
              src={`${
                menuDropDownFullScreen.name === "appointment" ? PulseIconBlue : PulseIcon 
              }`}

              alt="" />
            </div>

            <Link className="maweidi-link " to="/appointment">
              <span style={{ display: `${menuLeftText}` }}>
                <p
                  className={`mb-0 pl-lg-3 dashboard-left-icon-text ${
                    menuDropDownFullScreen.name === "appointment"
                      ? "seleted-menu"
                      : ""
                  } `}
                  style={{ color: "#535353" }}
                  onClick={() => {
                    setMenuDropDownFullScreen({
                      ...menuDropDownFullScreen,
                      name: "appointment",
                      toggle: !menuDropDownFullScreen.toggle,
                    });

                    setMobileMenu1(!MobileMenu1);
                  }}
                >
                  Appointments
                </p>
              </span>
            </Link>
          </div>

          <div
            className={` ${menuLeftRightDropDown2} px-0 d-flex align-items-center justify-content-end`}
          >
            {/* <img 
                        onClick={() => {
setMenuDropDownFullScreen(
    { name: "dashboard", toggle: !menuDropDownFullScreen.toggle }
)

                        }} 
        src={DownIcon} alt="" style={{ display: `${menuLeftText}` }} /> */}
          </div>

          {/* { menuDropDownFullScreen.toggle && menuDropDownFullScreen.name === 'dashboard' &&

        <p>sdf</p>
      
    } */}
        </div>
      </div>

      <div
        className={`mt-lg-4 mt-0 pt-1 d-flex align-items-center ${menuIconCenter} ${menuIconLeftPadding}`}
      >
        <div className=" row" style={{ display: `${menuLeftText}`, width: "100%" }}>
          <div
            className={`${menuLeftRightDropDown1} d-flex align-items-center ${menuIconCenter}`}
          >
            <div className="  dashboard-left-icon">
              <img className="py-1" 
              
              src={`${
                menuDropDownFullScreen.name === "hospital" ? HospitalIconBlue : HospitalIcon
              }`}
              
              alt="" />
            </div>

            <Link className="maweidi-link " to='/hospital'>
              <span style={{ display: `${menuLeftText}` }}>
                <p
                 className={`mb-0 pl-lg-3 dashboard-left-icon-text ${
                  menuDropDownFullScreen.name === "hospital"
                    ? "seleted-menu"
                    : ""
                } `}
                  style={{ color: "#535353" }}
                  onClick={() => {
                    setMenuDropDownFullScreen({
                      ...menuDropDownFullScreen,
                      name: "hospital",
                      toggle: !menuDropDownFullScreen.toggle,
                    });
                    setMobileMenu1(!MobileMenu1);
                  }}
                >
                  Hospitals
                </p>

                {/* <p
                  
                  style={{ color: "#535353" }}
                 
                >
                  Pharmacy
                </p> */}


              </span>
            </Link>
          </div>

          <div
            className={` ${menuLeftRightDropDown2} px-0 d-flex align-items-center justify-content-end`}
          >
            {/* <img 
                        onClick={() => {
setMenuDropDownFullScreen(
    { name: "dashboard", toggle: !menuDropDownFullScreen.toggle }
)

                        }} 
        src={DownIcon} alt="" style={{ display: `${menuLeftText}` }} /> */}
          </div>

          {/* { menuDropDownFullScreen.toggle && menuDropDownFullScreen.name === 'dashboard' &&

        <p>sdf</p>
      
    } */}
        </div>
      </div>

{/* doctor */}

      <div
        className={`mt-lg-4 mt-0 pt-1 d-flex align-items-center ${menuIconCenter} ${menuIconLeftPadding}`}
      >
        <div className=" row" style={{ display: `${menuLeftText}`, width: "100%" }}>
          <div
            className={`${menuLeftRightDropDown1} d-flex align-items-center ${menuIconCenter}`}
          >
            <div className="  dashboard-left-icon">
            {/* <svg> */}
              <img  className="py-1" src={`${
                    menuDropDownFullScreen.name === "doc" ? DoctorIconBlue : DoctorIcon 
                  }`} alt="" />
              {/* </svg> */}
            </div>

            <Link className="maweidi-link " to="alldoctors">
              <span style={{ display: `${menuLeftText}` }}>
                <p
                  className={`mb-0 pl-lg-3 dashboard-left-icon-text ${
                    menuDropDownFullScreen.name === "doc" ? "seleted-menu" : ""
                  } `}
                  style={{ color: "#535353" }}
                  onClick={() => {
                    setMenuDropDownFullScreen({
                      ...menuDropDownFullScreen,
                      name: "doc",
                      toggle: !menuDropDownFullScreen.toggle,
                    });
                    setMobileMenu1(!MobileMenu1);
                  }}
                >
                  Doctors
                </p>
              </span>
            </Link>
          </div>

          <div
            className={` ${menuLeftRightDropDown2} px-0 d-flex align-items-center justify-content-end`}
          >
            <img
              className="size-small-screen"
              onClick={() => {
                setMenuDropDownFullScreen({
                  ...menuDropDownFullScreen,
                  name: "doc",
                  toggle: !menuDropDownFullScreen.toggle,
                });
                // setMobileMenu1(!MobileMenu1)
              }}
              
              src={`${
                menuDropDownFullScreen.name === "doc" ? DownIconBlue : DownIcon
              }`}
              alt=""
              style={{ display: `${menuLeftText}` }}
            />
          </div>

          {menuDropDownFullScreen.toggle &&
            menuDropDownFullScreen.name === "doc" && (
              <>
                <div className="sub-menu1-top-padding sub-menu1-1st  col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // setMobileMenu1(!MobileMenu1)
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "alldoc",
                        },
                      }));
                    }}
                  />

                  <Link className="maweidi-link " to="/alldoctors">
                    <span
                      className={`pl-lg-2 ${
                        menuDropDownFullScreen.subMenuMobile.subname == "alldoc"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "alldoc",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      All Doctors
                    </span>
                  </Link>
                </div>

                {/* <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname ==
                      "alldoc" && (
                      <>
                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 1
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 2
                          </p>
                        </div>
                      </>
                    )}
                </div> */}

                <div className="sub-menu1-top-padding col-12 mt-2 pt-1 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}
                      // setMobileMenu1(!MobileMenu1)
                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "adddoc",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/adddoctors">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname == "adddoc"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "adddoc",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      Add Doctor
                    </span>
                  </Link>
                </div>
              </>
            )}
        </div>
      </div>

      <div
        className={`mt-lg-4 mt-0 pt-1 d-flex align-items-center ${menuIconCenter} ${menuIconLeftPadding}`}
      >
        <div className=" row" style={{ display: `${menuLeftText}`, width: "100%" }}>
          <div
            className={`${menuLeftRightDropDown1} d-flex align-items-center ${menuIconCenter}`}
          >
            <div className="  dashboard-left-icon">
              <img className="py-1" 
              
              src={`${
                menuDropDownFullScreen.name === "patient" ? PatientIconBlue : PatientIcon 
              }`}
              
              alt="" />
            </div>

            <Link className="maweidi-link " to="allpatients">
              <span style={{ display: `${menuLeftText}` }}>
                <p
                  className={`mb-0 pl-lg-3 dashboard-left-icon-text ${
                    menuDropDownFullScreen.name === "patient"
                      ? "seleted-menu"
                      : ""
                  } `}
                  style={{ color: "#535353" }}
                  onClick={() => {
                    setMenuDropDownFullScreen({
                      ...menuDropDownFullScreen,
                      name: "patient",
                      toggle: !menuDropDownFullScreen.toggle,
                    });
                    setMobileMenu1(!MobileMenu1);
                  }}
                >
                  Patients
                </p>
              </span>
            </Link>
          </div>

          <div
            className={` ${menuLeftRightDropDown2} px-0 d-flex align-items-center justify-content-end`}
          >
            <img
              className="size-small-screen"
              onClick={() => {
                setMenuDropDownFullScreen({
                  ...menuDropDownFullScreen,
                  name: "patient",
                  toggle: !menuDropDownFullScreen.toggle,
                });
              }}
              src={`${
                menuDropDownFullScreen.name === "patient" ? DownIconBlue : DownIcon
              }`}
              alt=""
              style={{ display: `${menuLeftText}` }}
            />
          </div>

          {menuDropDownFullScreen.toggle &&
            menuDropDownFullScreen.name === "patient" && (
              <>
                <div className="sub-menu1-top-padding col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "allpatient",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/allpatients">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname ==
                        "allpatient"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "allpatient",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      All Patients
                    </span>
                  </Link>
                </div>

                {/* <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname ==
                      "allpatient" && (
                      <>
                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 1
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 2
                          </p>
                        </div>
                      </>
                    )}
                </div> */}

                <div className="sub-menu1-top-padding col-12 mt-2 pt-1 ml-5 left-drop-down d-flex align-items-center">
                  <img className="" src={LeftDropIcon} alt="" />
                  <Link className="maweidi-link " to="/addpatient">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname ==
                        "addpatient"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "addpatient",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      Add Patients
                    </span>
                  </Link>
                </div>
              </>
            )}
        </div>
      </div>

      {/* pharmacy */}

      <div
        className={`mt-lg-4 mt-0 pt-1 d-flex align-items-center ${menuIconCenter} ${menuIconLeftPadding}`}
      >
        <div className=" row" style={{ display: `${menuLeftText}`, width: "100%" }}>
          <div
            className={`${menuLeftRightDropDown1} d-flex align-items-center ${menuIconCenter}`}
          >
            <div className="  dashboard-left-icon">
              <img className="py-0" style={{width:"20px"}} 
              
              src={`${
                menuDropDownFullScreen.name === "pharmacy" ? PharmacyIcon : PharmacyIconBlack 
              }`}

              alt="" />
            </div>

            <Link className="maweidi-link " to="pharmacy">
              <span style={{ display: `${menuLeftText}` }}>
                <p
                  className={`mb-0 pl-lg-3 dashboard-left-icon-text ${
                    menuDropDownFullScreen.name === "pharmacy"
                      ? "seleted-menu"
                      : ""
                  } `}
                  style={{ color: "#535353" }}
                  onClick={() => {
                    setMenuDropDownFullScreen({
                      ...menuDropDownFullScreen,
                      name: "pharmacy",
                      toggle: !menuDropDownFullScreen.toggle,
                    });
                    setMobileMenu1(!MobileMenu1);
                  }}
                >
                  Pharmacy
                </p>
              </span>
            </Link>
          </div>

          <div
            className={` ${menuLeftRightDropDown2} px-0 d-flex align-items-center justify-content-end`}
          >
            <img
              className="size-small-screen"
              onClick={() => {
                setMenuDropDownFullScreen({
                  ...menuDropDownFullScreen,
                  name: "pharmacy",
                  toggle: !menuDropDownFullScreen.toggle,
                });
              }}
              src={`${
                menuDropDownFullScreen.name === "pharmacy" ? DownIconBlue : DownIcon
              }`}
              alt=""
              style={{ display: `${menuLeftText}` }}
            />
          </div>

          {menuDropDownFullScreen.toggle &&
            menuDropDownFullScreen.name === "pharmacy" && (
              <>
                {/* 1st Pharmacy (1) sub option  */}

                <div className="sub-menu1-top-padding col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "pharmacy",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/pharmacy">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname ==
                        "pharmacy"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "pharmacy",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      Pharmacy List
                    </span>
                  </Link>
                </div>

                {/* <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname ==
                      "pharmacy" && (
                      <>
                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 1
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 2
                          </p>
                        </div>
                      </>
                    )}
                </div> */}

                {/* 2nd Pharmacy (1) sub option  */}

                <div className="sub-menu1-top-padding col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "pharmacyshop",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/pharmacyshop">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname ==
                        "pharmacyshop"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "pharmacyshop",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      Shop
                    </span>
                  </Link>
                </div>

                {/* <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname ==
                      "pharmacyshop" && (
                      <>
                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 1
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 2
                          </p>
                        </div>
                      </>
                    )}
                </div> */}

                {/* 3rd Pharmacy (1) sub option  */}

                <div className="sub-menu1-top-padding col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "pharmacyshopdetail",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/pharmacyshopdetail">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname ==
                        "pharmacyshopdetail"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "pharmacyshopdetail",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      Shop Detail
                    </span>
                  </Link>
                </div>

                {/* <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname ==
                      "pharmacyshopdetail" && (
                      <>
                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 1
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 2
                          </p>
                        </div>
                      </>
                    )}
                </div> */}

                {/* 4th Pharmacy (1) sub option  */}

           

              </>
            )}
        </div>
      </div>

      {/* Laboratory */}

      {/* <div
        className={`mt-lg-4 mt-0 pt-1 d-flex align-items-center ${menuIconCenter} ${menuIconLeftPadding}`}
      > */}
        <div> 
          {/* this div is replica of upper div */}
        <div className=" row" style={{ display: `${menuLeftText}`, width: "100%" }}>
          {/* <div
            className={`${menuLeftRightDropDown1} d-flex align-items-center ${menuIconCenter}`}
          >
            <div className="  dashboard-left-icon">
              <img className="py-1" src={LaboratoryIcon} alt="" />
            </div>

            <Link className="maweidi-link " to="laboratory">
              <span style={{ display: `${menuLeftText}` }}>
                <p
                  className={`mb-0 pl-lg-3 dashboard-left-icon-text ${
                    menuDropDownFullScreen.name === "laboratory"
                      ? "seleted-menu"
                      : ""
                  } `}
                  style={{ color: "#535353" }}
                  onClick={() => {
                    setMenuDropDownFullScreen({
                      ...menuDropDownFullScreen,
                      name: "laboratory",
                      toggle: !menuDropDownFullScreen.toggle,
                    });
                    setMobileMenu1(!MobileMenu1);
                  }}
                >
                  Laboratory
                </p>
              </span>
            </Link>
          </div>

          <div
            className={` ${menuLeftRightDropDown2} px-0 d-flex align-items-center justify-content-end`}
          >
            <img
              className="size-small-screen"
              onClick={() => {
                setMenuDropDownFullScreen({
                  ...menuDropDownFullScreen,
                  name: "laboratory",
                  toggle: !menuDropDownFullScreen.toggle,
                });
              }}
              src={`${
                menuDropDownFullScreen.name === "laboratory" ? DownIconBlue : DownIcon
              }`}
              alt=""
              style={{ display: `${menuLeftText}` }}
            />
          </div> */}

          {menuDropDownFullScreen.toggle &&
            menuDropDownFullScreen.name === "laboratory" && (
              <>
                {/* 1st Laboratory (1) sub option  */}

                <div className="sub-menu1-top-padding col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "laboratorylist",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/laboratory">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname ==
                        "laboratorylist"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "laboratorylist",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      Laboratory List
                    </span>
                  </Link>
                </div>

                {/* <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname ==
                      "laboratorylist" && (
                      <>
                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 1
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 2
                          </p>
                        </div>
                      </>
                    )}
                </div> */}

                {/* 2nd Laboratory (1) sub option  */}

                <div className="sub-menu1-top-padding col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "bloodtest",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/bloodtest">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname ==
                        "bloodtest"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "bloodtest",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      Blood Test
                    </span>
                  </Link>
                </div>

                <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname ==
                      "bloodtest" && (
                      <>
                        <div className="pl-5 ml-3 ">
                          <p
                            className="mb-0 pt-2 third-sub-menu"
                            style={{ fontSize: "12px" }}
                          >
                            <img className="" src={LeftDropIcon} alt="" />
                            {/* <Link className="maweidi-link " to="/bloodtest/orderlist"> */}
                            <span className="pl-1">Ordered List</span>
                            {/* </Link> */}
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                          <p
                            className="mb-0 pt-2 third-sub-menu"
                            style={{ fontSize: "12px" }}
                          >
                            <img className="" src={LeftDropIcon} alt="" />
                            <Link
                              className="maweidi-link "
                              to="/bloodtest/orderlist"
                            >
                              <span className="pl-1">Checkout</span>
                            </Link>
                          </p>
                        </div>
                      </>
                    )}
                </div>

                {/* 3rd Laboratory (1) sub option  */}

                <div className="sub-menu1-top-padding col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "xray",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/xray">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname == "xray"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "laboratoryxray",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      X-Rays
                    </span>
                  </Link>
                </div>

                <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname == "xray" && (
                      <>
                        <div className="pl-5 ml-3">
                          <p
                            className="mb-0 pt-2 third-sub-menu"
                            style={{ fontSize: "12px" }}
                          >
                            <img className="" src={LeftDropIcon} alt="" />{" "}
                            <span className="pl-1 ">
                              <Link
                                className="maweidi-link "
                                to="/xray/orderlist"
                              >
                                {" "}
                                Ordered List{" "}
                              </Link>
                            </span>
                          </p>
                        </div>
                        {/* 
                        <div className="pl-5 ml-3">
                          <p
                            className="mb-0 pt-2 third-sub-menu"
                            style={{ fontSize: "12px" }}
                          >
                            <img className="" src={LeftDropIcon} alt="" />{" "}
                            <span className="pl-1 ">
                            <Link className="maweidi-link " to="/xray/orderlist/xraycartdetail">
                              Checkout
                              </Link>
                              </span>
                          </p>
                        </div> */}

                        {/* <>
                        <div className="pl-5 ml-3 ">
                          <p className="mb-0 pt-2 third-sub-menu" style={{ fontSize: "12px" }}>
                       <img className='' src={LeftDropIcon} alt="" />   <span className='pl-1' >Ordered List</span>
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                        <p className="mb-0 pt-2 third-sub-menu" style={{ fontSize: "12px" }}>
                       <img className='' src={LeftDropIcon} alt="" />   <span className='pl-1' >Checkout</span>
                          </p>
                        </div>
                      </> */}
                      </>
                    )}
                </div>
              </>
            )}
        </div>
      </div>

      {/* Blood donation */}

      {/* <div
        className={`mt-lg-4 mt-0 pt-1 d-flex align-items-center ${menuIconCenter} ${menuIconLeftPadding}`}
      > */}
          <div> 
          {/* this div is replica of upper div */}
        <div className=" row" style={{ display: `${menuLeftText}`, width: "100%" }}>
          {/* <div
            className={`${menuLeftRightDropDown1} d-flex align-items-center ${menuIconCenter}`}
          >
            <div className="  dashboard-left-icon">
              <img className="py-1" src={`${
                menuDropDownFullScreen.name === "blooddonation" ? BloodIconBlue : BloodIconBlack 
              }`} alt="" />
            </div>

            <Link className="maweidi-link " to="blood-donation">
              <span style={{ display: `${menuLeftText}` }}>
                <p
                  className={`mb-0 pl-lg-3 dashboard-left-icon-text ${
                    menuDropDownFullScreen.name === "blooddonation"
                      ? "seleted-menu"
                      : ""
                  } `}
                  style={{ color: "#535353" }}
                  onClick={() => {
                    setMenuDropDownFullScreen({
                      ...menuDropDownFullScreen,
                      name: "blooddonation",
                      toggle: !menuDropDownFullScreen.toggle,
                    });
                    setMobileMenu1(!MobileMenu1);
                  }}
                >
                  Blood Donation
                </p>
              </span>
            </Link>
          </div> */}

          {/* <div
            className={` ${menuLeftRightDropDown2} px-0 d-flex align-items-center justify-content-end`}
          >
            <img
              className="size-small-screen"
              onClick={() => {
                setMenuDropDownFullScreen({
                  ...menuDropDownFullScreen,
                  name: "laboratory",
                  toggle: !menuDropDownFullScreen.toggle,
                });
              }}
              src={DownIcon}
              alt=""
              style={{ display: `${menuLeftText}` }}
            />
          </div> */}

          {menuDropDownFullScreen.toggle &&
            menuDropDownFullScreen.name === "blooddonation" && (
              <>
                {/* 1st Laboratory (1) sub option  */}
                {/* 
                <div className="sub-menu1-top-padding col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "laboratorylist",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/laboratory">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname ==
                        "laboratorylist"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "laboratorylist",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      Laboratory List
                    </span>
                  </Link>
                </div>

                <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname ==
                      "laboratorylist" && (
                      <>
                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 1
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 2
                          </p>
                        </div>
                      </>
                    )}
                </div> */}

                {/* 2nd Laboratory (1) sub option  */}

                {/* <div className="sub-menu1-top-padding col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "bloodtest",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/bloodtest">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname ==
                        "bloodtest"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "bloodtest",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      Blood Test
                    </span>
                  </Link>
                </div> */}

                {/* <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname ==
                      "bloodtest" && (
                      <>
                        <div className="pl-5 ml-3 ">
                          <p
                            className="mb-0 pt-2 third-sub-menu"
                            style={{ fontSize: "12px" }}
                          >
                            <img className="" src={LeftDropIcon} alt="" />
                            <span className="pl-1">Ordered List</span>
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                          <p
                            className="mb-0 pt-2 third-sub-menu"
                            style={{ fontSize: "12px" }}
                          >
                            <img className="" src={LeftDropIcon} alt="" />
                            <Link
                              className="maweidi-link "
                              to="/bloodtest/orderlist"
                            >
                              <span className="pl-1">Checkout</span>
                            </Link>
                          </p>
                        </div>
                      </>
                    )}
                </div> */}

                {/* 3rd Laboratory (1) sub option  */}

                {/* <div className="sub-menu1-top-padding col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "xray",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/xray">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname == "xray"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "laboratoryxray",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      X-Rays
                    </span>
                  </Link>
                </div> */}

                <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname == "xray" && (
                      <>
                        {/* <div className="pl-5 ml-3">
                          <p
                            className="mb-0 pt-2 third-sub-menu"
                            style={{ fontSize: "12px" }}
                          >
                            <img className="" src={LeftDropIcon} alt="" />{" "}
                            <span className="pl-1 ">
                              <Link className="maweidi-link " to="/xray/orderlist">
                                {" "}
                                Ordered List{" "}
                              </Link>
                            </span>
                          </p>
                        </div> */}
                        {/* 
                        <div className="pl-5 ml-3">
                          <p
                            className="mb-0 pt-2 third-sub-menu"
                            style={{ fontSize: "12px" }}
                          >
                            <img className="" src={LeftDropIcon} alt="" />{" "}
                            <span className="pl-1 ">
                            <Link className="maweidi-link " to="/xray/orderlist/xraycartdetail">
                              Checkout
                              </Link>
                              </span>
                          </p>
                        </div> */}

                        {/* <>
                        <div className="pl-5 ml-3 ">
                          <p className="mb-0 pt-2 third-sub-menu" style={{ fontSize: "12px" }}>
                       <img className='' src={LeftDropIcon} alt="" />   <span className='pl-1' >Ordered List</span>
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                        <p className="mb-0 pt-2 third-sub-menu" style={{ fontSize: "12px" }}>
                       <img className='' src={LeftDropIcon} alt="" />   <span className='pl-1' >Checkout</span>
                          </p>
                        </div>
                      </> */}
                      </>
                    )}
                </div>
              </>
            )}
        </div>
      </div>

      {/* Home Service Provider */}

      {/* <div
        className={`mt-lg-4 mt-0 pt-1 d-flex align-items-center ${menuIconCenter} ${menuIconLeftPadding}`}
      > */}
          <div> 
          {/* this div is replica of upper div */}
        <div className=" row" style={{ display: `${menuLeftText}`, width: "100%" }}>
          {/* <div
            className={`${menuLeftRightDropDown1} d-flex align-items-center ${menuIconCenter}`}
          >
            <div className="  dashboard-left-icon">
              <img className="py-1" src={`${
                menuDropDownFullScreen.name === "homeservice" ? HomeServiceIconBlue : HomeServiceIcon 
              }`} alt="" />
            </div>

            <Link className="maweidi-link " to="laboratory">
              <span style={{ display: `${menuLeftText}` }}>
                <p
                  className={`mb-0 pl-lg-3 dashboard-left-icon-text ${
                    menuDropDownFullScreen.name === "homeservice"
                      ? "seleted-menu"
                      : ""
                  } `}
                  style={{ color: "#535353" }}
                  onClick={() => {
                    setMenuDropDownFullScreen({
                      ...menuDropDownFullScreen,
                      name: "homeservice",
                      toggle: !menuDropDownFullScreen.toggle,
                    });
                    setMobileMenu1(!MobileMenu1);
                  }}
                >
                  Home Service Provider
                </p>
              </span>
            </Link>
          </div>

          <div
            className={` ${menuLeftRightDropDown2} px-0 d-flex align-items-center justify-content-end`}
          >
            <img
              className="size-small-screen"
              onClick={() => {
                setMenuDropDownFullScreen({
                  ...menuDropDownFullScreen,
                  name: "homeservice",
                  toggle: !menuDropDownFullScreen.toggle,
                });
              }}
              src={DownIcon}
              alt=""
              style={{ display: `${menuLeftText}` }}
            />
          </div> */}

          {menuDropDownFullScreen.toggle &&
            menuDropDownFullScreen.name === "homeservice" && (
              <>
                {/* 1st Laboratory (1) sub option  */}

                <div className="sub-menu1-top-padding col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "laboratorylist",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/laboratory">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname ==
                        "laboratorylist"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "laboratorylist",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      Laboratory List
                    </span>
                  </Link>
                </div>

                {/* <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname ==
                      "laboratorylist" && (
                      <>
                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 1
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 2
                          </p>
                        </div>
                      </>
                    )}
                </div> */}

                {/* 2nd Laboratory (1) sub option  */}

                <div className="sub-menu1-top-padding col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "bloodtest",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/bloodtest">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname ==
                        "bloodtest"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "bloodtest",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      Blood Test
                    </span>
                  </Link>
                </div>

                <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname ==
                      "bloodtest" && (
                      <>
                        <div className="pl-5 ml-3 ">
                          <p
                            className="mb-0 pt-2 third-sub-menu"
                            style={{ fontSize: "12px" }}
                          >
                            <img className="" src={LeftDropIcon} alt="" />
                            {/* <Link className="maweidi-link " to="/bloodtest/orderlist"> */}
                            <span className="pl-1">Ordered List</span>
                            {/* </Link> */}
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                          <p
                            className="mb-0 pt-2 third-sub-menu"
                            style={{ fontSize: "12px" }}
                          >
                            <img className="" src={LeftDropIcon} alt="" />
                            <Link
                              className="maweidi-link "
                              to="/bloodtest/orderlist"
                            >
                              <span className="pl-1">Checkout</span>
                            </Link>
                          </p>
                        </div>
                      </>
                    )}
                </div>

                {/* 3rd Laboratory (1) sub option  */}

                <div className="sub-menu1-top-padding col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "xray",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/xray">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname == "xray"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "laboratoryxray",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      X-Rays
                    </span>
                  </Link>
                </div>

                <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname == "xray" && (
                      <>
                        <div className="pl-5 ml-3">
                          <p
                            className="mb-0 pt-2 third-sub-menu"
                            style={{ fontSize: "12px" }}
                          >
                            <img className="" src={LeftDropIcon} alt="" />{" "}
                            <span className="pl-1 ">
                              <Link
                                className="maweidi-link "
                                to="/xray/orderlist"
                              >
                                {" "}
                                Ordered List{" "}
                              </Link>
                            </span>
                          </p>
                        </div>
                        {/* 
                        <div className="pl-5 ml-3">
                          <p
                            className="mb-0 pt-2 third-sub-menu"
                            style={{ fontSize: "12px" }}
                          >
                            <img className="" src={LeftDropIcon} alt="" />{" "}
                            <span className="pl-1 ">
                            <Link className="maweidi-link " to="/xray/orderlist/xraycartdetail">
                              Checkout
                              </Link>
                              </span>
                          </p>
                        </div> */}

                        {/* <>
                        <div className="pl-5 ml-3 ">
                          <p className="mb-0 pt-2 third-sub-menu" style={{ fontSize: "12px" }}>
                       <img className='' src={LeftDropIcon} alt="" />   <span className='pl-1' >Ordered List</span>
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                        <p className="mb-0 pt-2 third-sub-menu" style={{ fontSize: "12px" }}>
                       <img className='' src={LeftDropIcon} alt="" />   <span className='pl-1' >Checkout</span>
                          </p>
                        </div>
                      </> */}
                      </>
                    )}
                </div>
              </>
            )}
        </div>
      </div>

      <div
        className={`mt-lg-4 mt-0 pt-1 d-flex align-items-center ${menuIconCenter} ${menuIconLeftPadding}`}
      >
        <div className=" row" style={{ display: `${menuLeftText}`, width: "100%" }}>
          <div
            className={`${menuLeftRightDropDown1} d-flex align-items-center ${menuIconCenter}`}
          >
            <div className="  dashboard-left-icon">
            {/* <svg> */}
              <img  className="py-1" src={`${
                    menuDropDownFullScreen.name === "bannerpromo" ? BannerpromoBlue : Bannerpromo 
                  }`} alt="" />
              {/* </svg> */}
            </div>

            <Link className="maweidi-link " to="bannerpromo">
              <span style={{ display: `${menuLeftText}` }}>
                <p
                  className={`mb-0 pl-lg-3 dashboard-left-icon-text ${
                    menuDropDownFullScreen.name === "bannerpromo" ? "seleted-menu" : ""
                  } `}
                  style={{ color: "#535353" }}
                  onClick={() => {
                    setMenuDropDownFullScreen({
                      ...menuDropDownFullScreen,
                      name: "bannerpromo",
                      toggle: !menuDropDownFullScreen.toggle,
                    });
                    setMobileMenu1(!MobileMenu1);
                  }}
                >
                  Banner and Promo
                </p>
              </span>
            </Link>
          </div>

          <div
            className={` ${menuLeftRightDropDown2} px-0 d-flex align-items-center justify-content-end`}
          >
            {/* <img
              className="size-small-screen"
              onClick={() => {
                setMenuDropDownFullScreen({
                  ...menuDropDownFullScreen,
                  name: "bannerpromo",
                  toggle: !menuDropDownFullScreen.toggle,
                });
                // setMobileMenu1(!MobileMenu1)
              }}
              
              src={`${
                menuDropDownFullScreen.name === "bannerpromo" ? DownIconBlue : DownIcon
              }`}
              alt=""
              style={{ display: `${menuLeftText}` }}
            /> */}
          </div>

          {/* {menuDropDownFullScreen.toggle &&
            menuDropDownFullScreen.name === "bannerpromo" && (
              <>
                <div className="sub-menu1-top-padding sub-menu1-1st  col-12 mt-lg-2 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // setMobileMenu1(!MobileMenu1)
                      // let sbtoggle = {"subtoggle":false}

                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "alldoc",
                        },
                      }));
                    }}
                  />

                  <Link className="maweidi-link " to="/alldoctors">
                    <span
                      className={`pl-lg-2 ${
                        menuDropDownFullScreen.subMenuMobile.subname == "alldoc"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "alldoc",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      All Doctors
                    </span>
                  </Link>
                </div>

                <div className="col-12">
                  {menuDropDownFullScreen.subMenuMobile.subtoggle &&
                    menuDropDownFullScreen.subMenuMobile.subname ==
                      "alldoc" && (
                      <>
                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 1
                          </p>
                        </div>

                        <div className="pl-5 ml-3">
                          <p className="mb-0" style={{ fontSize: "12px" }}>
                            Sufian: 2
                          </p>
                        </div>
                      </>
                    )}
                </div>

                <div className="sub-menu1-top-padding col-12 mt-2 pt-1 ml-5 left-drop-down d-flex align-items-center">
                  <img
                    className=""
                    src={LeftDropIcon}
                    alt=""
                    onClick={() => {
                      // let sbtoggle = {"subtoggle":false}
                      // setMobileMenu1(!MobileMenu1)
                      setMenuDropDownFullScreen((prevState) => ({
                        ...prevState,
                        subMenuMobile: {
                          ...prevState.subMenuMobile,
                          // subtoggle: true, // or any other value you want to update it to

                          subtoggle: !prevState.subMenuMobile.subtoggle,
                          subname: "adddoc",
                        },
                      }));
                    }}
                  />
                  <Link className="maweidi-link " to="/adddoctors">
                    <span
                      className={`pl-lg-2  ${
                        menuDropDownFullScreen.subMenuMobile.subname == "adddoc"
                          ? "seleted-menu"
                          : ""
                      } `}
                      onClick={() => {
                        // let sbtoggle = {"subtoggle":false}

                        setMenuDropDownFullScreen((prevState) => ({
                          ...prevState,
                          subMenuMobile: {
                            ...prevState.subMenuMobile,
                            // subtoggle: true, // or any other value you want to update it to

                            subtoggle: !prevState.subMenuMobile.subtoggle,
                            subname: "adddoc",
                          },
                        }));
                        setMobileMenu1(!MobileMenu1);
                      }}
                    >
                      Add Doctor
                    </span>
                  </Link>
                </div>
              </>
            )} */}
        </div>
      </div>

    </div>
  );
};

export default FullScreenMenu;
